import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyCBwgZU2QPtEoIYL_521mxmmVom6BlyvPw',
  authDomain: 'namasean.firebaseapp.com',
  projectId: 'namasean',
  storageBucket: 'namasean.appspot.com',
  messagingSenderId: '227396903297',
  appId: '1:227396903297:web:2f7c8d9b221b19ffb7c880',
}

firebase.initializeApp(firebaseConfig)

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.REACT_APP_STAGE === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const ChatKfairDb = getDbRef('chatKfair')
const ChatMcDb = getDbRef('chatMc')
const NoticeDb = getDbRef('notice')
const NotificationDb = getDbRef('pushNotifications')

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)

export { firebaseDb, firebaseAuth, ChatDb, ChatKfairDb, ChatMcDb, NoticeDb, NotificationDb, getUniqueSessionDb, getUserCountDb, getUserSessionDb, getOnlineStatusDb }
